import { Injectable } from '@angular/core';
import { add_to_cart_option_interface, facebookPixelEventType, facebookPixelParamsModel } from './facebook-pixel-model.model';


declare let fbq: any;




@Injectable({
  providedIn: 'root',
})
export class FacebookPixelService 
{

  currencyCode: string = 'usd';


  constructor() {}


  generalEvent(event: facebookPixelEventType, params: facebookPixelParamsModel) 
  {
    if (typeof fbq !== 'undefined') {
      fbq('track', event, params);
    }
  }


  addToCart(addToCartParams: add_to_cart_option_interface) 
  {
    if (typeof fbq !== 'undefined') {

      fbq('track', 'AddToCart', addToCartParams);
    }
  }


}
